export const TECHNICIAN_PREVISAO_SESSIONS = ['Previsto para hoje', 'Previstas para amanhã', 'FUTURA'];

export const TECHNICIAN_MENU_DROPDOWN_WIDTH = 220;
